
// Add Assignee
export const addAssigneeApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "ADD_ASSIGNEE_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ADD_ASSIGNEE_SUCCESS":
            return {
                ...state,
                loading: false,
                getAddAssigneeData: action.payload,
            };
        case "ADD_ASSIGNEE_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "ADD_ASSIGNEE_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getAddAssigneeData: null,
            };
        default:
            return state;
    }
}

// get Assignee
export const getAssigneesApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_ASSIGNEES_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_ASSIGNEES_SUCCESS":
            return {
                ...state,
                loading: false,
                getAssigneesData: action.payload,
            };
        case "GET_ASSIGNEES_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "GET_ASSIGNEES_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getAssigneesData: null,
            };
        default:
            return state;
    }
}

// add Comment
export const addCommentApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "ADD_COMMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ADD_COMMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getCommentsAddData: action.payload,
            };
        case "ADD_COMMENT_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "ADD_COMMENT_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getCommentsAddData: null,
            };
        default:
            return state;
    }
}

// add Document
export const addDocumentApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "ADD_DOCUMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "ADD_DOCUMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getDocumentAddData: action.payload,
            };
        case "ADD_DOCUMENT_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "ADD_DOCUMENT_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getDocumentAddData: null,
            };
        default:
            return state;
    }
}

// get Attachments
export const getAttachmentsApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_ATTACHMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_ATTACHMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getAttachmentData: action.payload,
            };
        case "GET_ATTACHMENT_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "GET_ATTACHMENT_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getAttachmentData: null,
            };
        default:
            return state;
    }
}

// get Attachments
export const applyTenderApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "APPLY_TENDER_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "APPLY_TENDER_SUCCESS":
            return {
                ...state,
                loading: false,
                getApplyTenderData: action.payload,
            };
        case "APPLY_TENDER_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "APPLY_TENDER_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getApplyTenderData: null,
            };
        default:
            return state;
    }
}

// get Assignee
export const getDepartmentUserApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "GET_USER_DEPARTMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "GET_USER_DEPARTMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getDepartmentUserData: action.payload,
            };
        case "GET_USER_DEPARTMENT_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "GET_USER_DEPARTMENT_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getDepartmentUserData: null,
            };
        default:
            return state;
    }
}

// add Document
export const deleteDocumentApiReducer = (state = {}, action) => {
    switch (action.type) {
        case "DELETE_DOCUMENT_REQUEST":
            return {
                ...state,
                loading: true,
            };
        case "DELETE_DOCUMENT_SUCCESS":
            return {
                ...state,
                loading: false,
                getDocumentDeleteData: action.payload,
            };
        case "DELETE_DOCUMENT_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case "DELETE_DOCUMENT_RESET":
            return {
                ...state,
                loading: false,
                error: null,
                getDocumentDeleteData: null,
            };
        default:
            return state;
    }
}